// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ButtonCounter_wrapper__mQLYd","inputNumber":"ButtonCounter_inputNumber__1WRTA"};